module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Color Legend of the Satisfaction Score"},"de":{"title":"Farblegende zum Zufriedenheit-Score"},"fr":{"title":"Légende des couleurs du score de satisfaction"},"it":{"title":"Leggenda a colori del punteggio di soddisfazione"}}')
  delete Component.options._Ctor
}
